// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const PageText_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.03 7.72-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53ZM15 4.81l2.69 2.69H15Zm3.75 15.44H5.25V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5v11.25Zm-3-7.5a.75.75 0 0 1-.75.75H9A.75.75 0 0 1 9 12h6a.75.75 0 0 1 .75.75Zm0 3a.75.75 0 0 1-.75.75H9A.75.75 0 0 1 9 15h6a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'PageText_Stroke2_Corner0_Rounded',
})

export const PageX_Stroke2_Corner0_Rounded_Large = createSinglePathSVG({
  path: 'm53.415 20.585-14-14A2 2 0 0 0 38 6H14a4 4 0 0 0-4 4v44a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V22a2 2 0 0 0-.585-1.415ZM40 12.828 47.172 20H40ZM50 54H14V10h22v12a2 2 0 0 0 2 2h12v30ZM39.415 33.415 34.828 38l4.587 4.585a2.001 2.001 0 0 1-2.83 2.83L32 40.828l-4.585 4.587a2.001 2.001 0 0 1-2.83-2.83L29.172 38l-4.587-4.585a2.001 2.001 0 0 1 2.83-2.83L32 35.172l4.585-4.587a2.001 2.001 0 0 1 2.83 2.83Z',
  viewBox: '0 0 64 64',
  glyph: 'PageX_Stroke2_Corner0_Rounded_Large',
})
